<template>
  <section class="login-page">
    <div class="login-panel">
      <div class="login-brand">
        <p class="login-kicker">11ecom Client Application</p>
        <h1>Billbee Control Center</h1>
        <p class="login-copy">
          Sign in with your backoffice user to access Mirakl, Billbee, DATEV, and task operations.
        </p>
      </div>

      <form class="login-form" @submit.prevent="submit">
        <div class="form-group">
          <label for="email">Backoffice Email</label>
          <input id="email" v-model.trim="email" type="email" autocomplete="username" required />
        </div>

        <div class="form-group">
          <label for="password">Password</label>
          <input id="password" v-model="password" type="password" autocomplete="current-password" required />
        </div>

        <div v-if="errorMessage" class="alert alert-danger">
          {{ errorMessage }}
        </div>

        <button class="btn btn-primary btn-lg login-submit" type="submit" :disabled="authStore.loading">
          {{ authStore.loading ? 'Signing in...' : 'Sign In' }}
        </button>
      </form>
    </div>
  </section>
</template>

<script>
import { useAuthStore } from '@/stores/authStore'

export default {
  name: 'LoginView',
  data() {
    return {
      email: '',
      password: '',
      errorMessage: ''
    }
  },
  mounted() {
    this.errorMessage = this.getRouteMessage()
  },
  computed: {
    authStore() {
      return useAuthStore()
    }
  },
  methods: {
    getRouteMessage() {
      if (this.$route.query.reason === 'session_expired') {
        return 'Your backoffice session expired. Please sign in again.'
      }

      return ''
    },
    async submit() {
      this.errorMessage = this.getRouteMessage()

      try {
        await this.authStore.login(this.email, this.password)
        const redirect = typeof this.$route.query.redirect === 'string' && this.$route.query.redirect !== ''
          ? this.$route.query.redirect
          : '/'
        await this.$router.replace(redirect)
      } catch (error) {
        this.errorMessage = this.authStore.error || 'Sign-in failed.'
      }
    }
  }
}
</script>

<style scoped>
.login-page {
  min-height: 100vh;
  display: grid;
  place-items: center;
  padding: 2rem;
  background:
    radial-gradient(circle at top left, rgba(22, 163, 74, 0.15), transparent 32rem),
    linear-gradient(135deg, #0f172a, #132238 52%, #1f2937);
}

.login-panel {
  width: min(100%, 28rem);
  padding: 2rem;
  border-radius: 1.25rem;
  background: rgba(255, 255, 255, 0.96);
  box-shadow: 0 2rem 4rem rgba(15, 23, 42, 0.3);
}

.login-brand {
  margin-bottom: 1.5rem;
}

.login-kicker {
  margin-bottom: 0.75rem;
  color: #15803d;
  font-size: 0.85rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.login-brand h1 {
  margin-bottom: 0.75rem;
  color: #0f172a;
  font-size: 2rem;
  line-height: 1.1;
}

.login-copy {
  color: #475569;
}

.login-form label {
  display: block;
  margin-bottom: 0.4rem;
  color: #0f172a;
  font-weight: 600;
}

.login-form input {
  width: 100%;
  padding: 0.8rem 0.9rem;
  border: 1px solid #cbd5e1;
  border-radius: 0.75rem;
  font: inherit;
}

.login-form input:focus {
  outline: 2px solid rgba(21, 128, 61, 0.18);
  border-color: #15803d;
}

.login-submit {
  width: 100%;
  justify-content: center;
  margin-top: 0.5rem;
}
</style>
